import * as React from 'react';
import { ArticleHeading4, ArticleParagraph2 } from '@cian/ui-kit/typography';
import classNames from 'clsx';

import * as styles from './styles.css';

interface IFlatsErrorProps {
  image: 'not-found' | 'start';
  title: string;
  text: React.ReactElement<unknown> | string | null;
}

export function FlatsError({ image, text, title }: IFlatsErrorProps) {
  return (
    <div className={styles['container']}>
      <div className={classNames(styles['image'], styles[image])} />
      <div className={styles['title']}>
        <ArticleHeading4 color="text-primary-default">{title}</ArticleHeading4>
      </div>
      {text && (
        <ArticleParagraph2 color={'gray60_100'} textAlign={'center'} data-mark="FlatsErrorText">
          {text}
        </ArticleParagraph2>
      )}
    </div>
  );
}
